/** Structured v1 JSON syncError with kind validation (written by serialiseSyncError). */
export const storedSyncErrorIsValidation = (tableAlias?: string): string => {
  const prefix = tableAlias ? `${tableAlias}.` : '';
  return `(
    (${prefix}syncError LIKE '%"version":1,%' OR ${prefix}syncError LIKE '%"version":1}%')
    AND ${prefix}syncError LIKE '%"kind":"validation"%'
  )`;
};

/** Record has a direct validation syncError or inherited validation flag from descendants. */
export const recordHasValidationIssueCondition = (tableAlias?: string): string => {
  const prefix = tableAlias ? `${tableAlias}.` : '';
  return `(${storedSyncErrorIsValidation(tableAlias)} OR ${prefix}treeSyncError = 1)`;
};

/**
 * Exclude records whose parent (via child association) also has an issue.
 * Only root issue rows should appear in validation-issues lists and counts.
 */
export const rootRecordOnlyNotExistsClause = (recordAlias: string): string => `
  NOT EXISTS (
    SELECT 1
    FROM associations a
    INNER JOIN attributes attr
      ON attr.id = a.attributeId
      AND attr.projectId = a.projectId
      AND attr.questionType = 'child'
    INNER JOIN records parent
      ON parent.id = a.sourceId
      AND parent.projectId = ${recordAlias}.projectId
    WHERE a.targetId = ${recordAlias}.id
      AND a.projectId = ${recordAlias}.projectId
      AND (${storedSyncErrorIsValidation('parent')} OR parent.treeSyncError = 1)
  )`;
